<template>
  <div>
    <p class="text-body px-4 md:px-8 mb-2">
      {{ $t('otp.sendCodeMessage', { phone: mobileLastFour }) }}
    </p>
    <p class="text-14 text-midGrey m-0">
      {{ $t('otp.sendCodeAdvice') }}
    </p>

    <div class="flex flex-col">
      <BaseButton
        :variant="customisedBranding ? 'outline' : 'primary'"
        :loading="sendingCode"
        class="!font-medium !text-body mt-6 mx-auto"
        @click.native="handleSendCode"
      >
        {{ $t('otp.send') }}
      </BaseButton>

      <p class="!text-body mt-4">
        {{ $t('otp.haveCode') }}
        <BaseButton
          variant="invisible"
          class="!inline-block !font-medium !text-body !text-blue !p-0 !mt-0 !no-underline"
          @click.native="handleShowEntry"
        >
          {{ $t('otp.enterCode') }}
        </BaseButton>
      </p>

      <ValidationError
        :hasError="!!error"
        :errorMessage="$t(error)"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue'
import BaseButton from '@/components/library/buttons/BaseButton.vue'
import ValidationError from '@/components/library/ValidationError.vue'

const props = defineProps({
  mobileLastFour: String,
  onSendCode: Function,
  error: String,
  customisedBranding: Boolean
})

const emit = defineEmits(['showEntry'])

const sendingCode = ref(false)

const handleShowEntry = () => {
  emit('showEntry')
}

const handleSendCode = async () => {
  sendingCode.value = true
  await props.onSendCode()
  sendingCode.value = false
}
</script>
